/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".delete-page__danger[_ngcontent-%COMP%]{color:#b92855;font-weight:700}.delete-page__footnote[_ngcontent-%COMP%]{margin:40px 0 20px;line-height:1.4}"];
export { styles as styles };
